export const getSiteProperties = (state) => state.siteProperties;
